export const getters = {
  forecastDemandList: (state) => state.forecastDemandList,
  eventOccurrenceList: (state) => state.eventOccurrenceList,
};
